import { ContactDto } from "./contact.dto";
import { IdentifiableDto } from "./identifiable.dto";

export class MatchedLeadsProductEmailRecipientDto extends IdentifiableDto {
    email: string;
    contact: ContactDto;
}